import { css } from '@emotion/react';

export const DirittoImageEditorBodyStyle = css`
  body > textarea {
    position: fixed !important;
  }
`;

export const DefaultFontFamily = css`
  font-family:
    Pretendard,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    'Open Sans',
    'Helvetica Neue',
    sans-serif;
`;

export const DirittoImageEditorStyle = css`
  /*!
 * TOAST UI ImageEditor
 * @version 3.15.2
 * @author NHN. FE Development Team <dl_javascript@nhn.com>
 * @license MIT
 */
  .tui-image-editor-container {
  }
  .tui-image-editor-container canvas {
    max-width: 100% !important;
    max-height: 100% !important;
  }
  .tui-image-editor-container div,
  .tui-image-editor-container input,
  .tui-image-editor-container label,
  .tui-image-editor-container li,
  .tui-image-editor-container ul {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -ms-user-select: none;
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    max-width: 100% !important;
    max-height: 100% !important;
  }
  .tui-image-editor-container .tui-image-editor-header {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-controls-buttons,
  .tui-image-editor-container .tui-image-editor-header-buttons {
    float: right;
    margin: 8px;
  }
  .tui-image-editor-container .tui-image-editor-controls-logo,
  .tui-image-editor-container .tui-image-editor-header-logo {
    float: left;
    padding: 17px;
    width: 30%;
  }
  .tui-image-editor-container .tui-image-editor-controls-buttons,
  .tui-image-editor-container .tui-image-editor-controls-logo {
    display: none;
    height: 100%;
    width: 270px;
  }
  .tui-image-editor-container .tui-image-editor-controls-buttons button,
  .tui-image-editor-container .tui-image-editor-controls-buttons div,
  .tui-image-editor-container .tui-image-editor-header-buttons button,
  .tui-image-editor-container .tui-image-editor-header-buttons div {
    border: 1px solid #ddd;
    border-radius: 20px;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0;
    position: relative;
    text-align: center;
    vertical-align: middle;
    width: 120px;
  }
  .tui-image-editor-container .tui-image-editor-download-btn {
    background-color: #fdba3b;
    border-color: #fdba3b;
    color: #fff;
  }
  .tui-image-editor-container .tui-image-editor-load-btn {
    bottom: 0;
    cursor: pointer;
    display: inline-block;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
  .tui-image-editor-container .tui-image-editor-main-container {
    background-color: transparent !important;
    width: 100% !important;
    height: 100% !important;
  }
  .tui-image-editor-container .tui-image-editor-main {
    width: 100% !important;
    height: 100% !important;
  }
  .tui-image-editor-container .tui-image-editor-wrap {
    bottom: 0;
    overflow: auto;
    width: 100% !important;
    height: 100% !important;
  }
  .tui-image-editor-container .tui-image-editor-wrap .tui-image-editor-size-wrap {
    display: table;
    height: 100%;
    width: 100%;
  }
  .tui-image-editor-container .tui-image-editor-wrap .tui-image-editor-size-wrap .tui-image-editor-align-wrap {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
  .tui-image-editor-container .tui-image-editor {
    display: initial;
    position: relative;
    top: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }
  .tui-image-editor-container .tui-image-editor-help-menu,
  .tui-image-editor-container .tui-image-editor-menu {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu > .tui-image-editor-item,
  .tui-image-editor-container .tui-image-editor-menu > .tui-image-editor-item {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu > .tui-image-editor-item[tooltip-content]:hover:before,
  .tui-image-editor-container .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:hover:before {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu > .tui-image-editor-item[tooltip-content]:hover:after,
  .tui-image-editor-container .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:hover:after {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu > .tui-image-editor-item.active,
  .tui-image-editor-container .tui-image-editor-menu > .tui-image-editor-item.active {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-wrap {
    position: relative;
  }
  .tui-image-editor-container .tui-image-editor-grid-visual {
    border: 1px solid rgba(255, 255, 255, 0.7);
    display: none;
    height: 100%;
    position: absolute;
    width: 100%;
  }
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-flip .tui-image-editor,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-rotate .tui-image-editor {
    transition: none;
  }
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-flip .tui-image-editor-grid-visual,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-resize .tui-image-editor-grid-visual,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-rotate .tui-image-editor-grid-visual {
    display: block;
  }
  .tui-image-editor-container .tui-image-editor-grid-visual table {
    border-collapse: collapse;
    height: 100%;
    width: 100%;
  }
  .tui-image-editor-container .tui-image-editor-grid-visual table td {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }
  .tui-image-editor-container .tui-image-editor-grid-visual table td.dot:before {
    background-color: #fff;
    border: 0;
    border-radius: 100%;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    content: '';
    height: 10px;
    position: absolute;
    width: 10px;
  }
  .tui-image-editor-container .tui-image-editor-grid-visual table td.dot.left-top:before {
    left: -5px;
    top: -5px;
  }
  .tui-image-editor-container .tui-image-editor-grid-visual table td.dot.right-top:before {
    right: -5px;
    top: -5px;
  }
  .tui-image-editor-container .tui-image-editor-grid-visual table td.dot.left-bottom:before {
    bottom: -5px;
    left: -5px;
  }
  .tui-image-editor-container .tui-image-editor-grid-visual table td.dot.right-bottom:before {
    bottom: -5px;
    right: -5px;
  }
  .tui-image-editor-container .tui-image-editor-submenu {
    bottom: 0;
    display: none;
    height: 150px;
    position: absolute;
    white-space: nowrap;
    width: 100%;
    z-index: 2;
  }
  .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-button:hover svg > use.active {
    display: block;
  }
  .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item li {
    display: inline-block;
    vertical-align: top;
  }
  .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item .tui-image-editor-newline {
    display: block;
    margin-top: 0;
  }
  .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item .tui-image-editor-button {
    cursor: pointer;
    display: inline-block;
    font-size: 11px;
    font-weight: 400;
    margin: 0 9px;
    position: relative;
  }
  .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item .tui-image-editor-button.preset {
    margin: 0 9px 20px 5px;
  }
  .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item label > span {
    cursor: pointer;
    display: inline-block;
    font-size: 11px;
    padding-top: 5px;
  }
  .tui-image-editor-container
    .tui-image-editor-submenu
    .tui-image-editor-submenu-item
    .tui-image-editor-button.apply
    label,
  .tui-image-editor-container
    .tui-image-editor-submenu
    .tui-image-editor-submenu-item
    .tui-image-editor-button.cancel
    label {
    vertical-align: 7px;
  }
  .tui-image-editor-container .tui-image-editor-submenu > div {
    display: none;
    vertical-align: bottom;
  }
  .tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-style {
    bottom: 0;
    display: block;
    left: 0;
    opacity: 0.95;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
  }
  .tui-image-editor-container .tui-image-editor-partition > div {
    border-left: 1px solid #3c3c3c;
    height: 52px;
    margin: 0 8px;
    width: 1px;
  }
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-filter .tui-image-editor-partition > div {
    height: 108px;
    margin: 0 29px 0 0;
  }
  .tui-image-editor-container .tui-image-editor-submenu-align {
    margin-right: 30px;
    text-align: left;
  }
  .tui-image-editor-container .tui-image-editor-submenu-align label > span {
    white-space: nowrap;
    width: 55px;
  }
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-crop
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-crop,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-draw
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-draw,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-filter
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-filter,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-flip
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-flip,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-icon
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-icon,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-mask
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-mask,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-resize
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-resize,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-rotate
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-rotate,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-shape
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-shape,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-text
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-text,
  .tui-image-editor-container
    .tui-image-editor-main.tui-image-editor-menu-zoom
    .tui-image-editor-submenu
    > div.tui-image-editor-menu-zoom {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-crop .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-draw .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-filter .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-flip .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-icon .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-mask .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-resize .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-rotate .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-shape .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-text .tui-image-editor-submenu,
  .tui-image-editor-container .tui-image-editor-main.tui-image-editor-menu-zoom .tui-image-editor-submenu {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu {
    border-radius: 20px;
    list-style: none;
    margin: 0 auto;
    padding: 0;
    position: absolute;
    text-align: center;
    vertical-align: middle;
    z-index: 2;
  }
  .tui-image-editor-container .tui-image-editor-help-menu .tie-panel-history {
    color: #444;
    cursor: auto;
    display: none;
    height: 276px;
    padding: 4px 2px;
    position: absolute;
    transform: translateX(calc(-50% + 12px));
    width: 196px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu .tie-panel-history .history-list {
    height: 268px;
    list-style: none;
    overflow: hidden scroll;
    padding: 0;
  }
  .tui-image-editor-container .tui-image-editor-help-menu .tie-panel-history .history-list .history-item {
    font-size: 11px;
    height: 24px;
    line-height: 24px;
  }
  .tui-image-editor-container
    .tui-image-editor-help-menu
    .tie-panel-history
    .history-list
    .history-item
    .tui-image-editor-history-item {
    cursor: pointer;
    height: 24px;
    position: relative;
  }
  .tui-image-editor-container
    .tui-image-editor-help-menu
    .tie-panel-history
    .history-list
    .history-item
    .tui-image-editor-history-item
    svg {
    height: 24px;
    width: 24px;
  }
  .tui-image-editor-container
    .tui-image-editor-help-menu
    .tie-panel-history
    .history-list
    .history-item
    .tui-image-editor-history-item
    span {
    display: inline-block;
    height: 24px;
    text-align: left;
    width: 128px;
  }
  .tui-image-editor-container
    .tui-image-editor-help-menu
    .tie-panel-history
    .history-list
    .history-item
    .tui-image-editor-history-item
    .history-item-icon {
    display: inline-block;
    height: 24px;
    left: 6px;
    position: absolute;
    top: 6px;
    width: 24px;
  }
  .tui-image-editor-container
    .tui-image-editor-help-menu
    .tie-panel-history
    .history-list
    .history-item
    .tui-image-editor-history-item
    .history-item-checkbox {
    display: none;
    height: 24px;
    position: absolute;
    right: -6px;
    top: 5px;
    width: 24px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu .tie-panel-history .history-list .history-item.selected-item {
  }
  .tui-image-editor-container
    .tui-image-editor-help-menu
    .tie-panel-history
    .history-list
    .history-item.selected-item
    .history-item-checkbox {
    display: inline-block;
  }
  .tui-image-editor-container .tui-image-editor-help-menu .tie-panel-history .history-list .history-item.disabled-item {
    color: #333;
    opacity: 0.3;
  }
  .tui-image-editor-container .tui-image-editor-help-menu .opened .tie-panel-history {
    display: block;
  }
  .tui-image-editor-container .tui-image-editor-help-menu .opened .tie-panel-history:before {
    content: '';
    display: inline-block;
    height: 0;
    margin: 0 auto;
    position: absolute;
    width: 0;
  }
  .tui-image-editor-container .filter-color-item {
    display: inline-block;
  }
  .tui-image-editor-container .filter-color-item .tui-image-editor-checkbox {
    display: block;
  }
  .tui-image-editor-container .tui-image-editor-checkbox-wrap {
    display: inline-block !important;
    text-align: left;
  }
  .tui-image-editor-container .tui-image-editor-checkbox-wrap.fixed-width {
    white-space: normal;
    width: 187px;
  }
  .tui-image-editor-container .tui-image-editor-checkbox {
    display: inline-block;
    margin: 1px 0;
  }
  .tui-image-editor-container .tui-image-editor-checkbox input {
    height: 14px;
    opacity: 0;
    width: 14px;
  }
  .tui-image-editor-container .tui-image-editor-checkbox > label > span {
    color: #fff;
    height: 14px;
    position: relative;
  }
  .tui-image-editor-container .tui-image-editor-checkbox > label > span:before,
  .tui-image-editor-container .tui-image-editor-checkbox input + label:before {
    border: 0;
    border-radius: 2px;
    box-sizing: border-box;
    content: '';
    display: inline-block;
    font-size: 11px;
    height: 14px;
    left: -19px;
    margin: 0;
    padding-top: 1px;
    position: absolute;
    text-align: center;
    top: 6px;
    width: 14px;
  }
  .tui-image-editor-container .tui-image-editor-checkbox input[type='checkbox']:checked + span:before {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAMBJREFUKBWVkjEOwjAMRe2WgZW7IIHEDdhghhuwcQ42rlJugAQS54Cxa5cq1QM5TUpByZfS2j9+dlJVt/tX5ZxbS4ZU9VLkQvSHKTIGRaVJYFmKrBbTCJxE2UgCdDzMZDkHrOV6b95V0US6UmgKodujEZbJg0B0ZgEModO5lrY1TMQf1TpyJGBEjD+E2NPN7ukIUDiF/BfEXgRiGEw8NgkffYGYwCi808fpn/6OvfUfsDr/Vc1IfRf8sKnFVqeiVQfDu0tf/nWH9gAAAABJRU5ErkJggg==);
    background-size: cover;
  }
  .tui-image-editor-container .tui-image-editor-selectlist-wrap {
    position: relative;
  }
  .tui-image-editor-container .tui-image-editor-selectlist-wrap select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    border: 1px solid #cbdbdb;
    border-radius: 0;
    height: 28px;
    margin-top: 4px;
    outline: 0;
    padding: 0 7px 0 10px;
    width: 100%;
  }
  .tui-image-editor-container .tui-image-editor-selectlist-wrap .tui-image-editor-selectlist {
    background-color: #fff;
    border: 1px solid #ccc;
    border-top: 0;
    display: none;
    padding: 4px 0;
    position: relative;
    top: -1px;
  }
  .tui-image-editor-container .tui-image-editor-selectlist-wrap .tui-image-editor-selectlist li {
    display: block;
    padding: 7px 10px;
    text-align: left;
  }
  .tui-image-editor-container .tui-image-editor-selectlist-wrap .tui-image-editor-selectlist li:hover {
    background-color: rgba(81, 92, 230, 0.05);
  }
  .tui-image-editor-container .tui-image-editor-selectlist-wrap:before {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAHlJREFUKBVjYBgFOEOAEVkmPDxc89+/f6eAYjzI4kD2FyYmJrOVK1deh4kzwRggGiQBVJCELAZig8SQNYHEmEEEMrh69eo1HR0dfqCYJUickZGxf9WqVf3IakBsFBthklpaWmVA9mEQhrJhUoTp0NBQCRAmrHL4qgAAuu4cWZOZIGsAAAAASUVORK5CYII=);
    background-size: cover;
    content: '';
    display: inline-block;
    height: 14px;
    position: absolute;
    right: 5px;
    top: 10px;
    width: 14px;
  }
  .tui-image-editor-container .tui-image-editor-selectlist-wrap select::-ms-expand {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-virtual-range-bar .tui-image-editor-disabled,
  .tui-image-editor-container .tui-image-editor-virtual-range-pointer .tui-image-editor-disabled,
  .tui-image-editor-container .tui-image-editor-virtual-range-subbar .tui-image-editor-disabled {
    backbround-color: red;
  }
  .tui-image-editor-container .tui-image-editor-range {
    display: inline-block;
    height: 17px;
    position: relative;
    top: 5px;
    width: 166px;
  }
  .tui-image-editor-container .tui-image-editor-virtual-range-bar {
    background-color: #666;
    height: 2px;
    position: absolute;
    top: 7px;
    width: 100%;
  }
  .tui-image-editor-container .tui-image-editor-virtual-range-subbar {
    background-color: #d1d1d1;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
  }
  .tui-image-editor-container .tui-image-editor-virtual-range-pointer {
    background-color: #fff;
    border-radius: 100%;
    cursor: pointer;
    height: 12px;
    left: 0;
    position: absolute;
    top: -5px;
    width: 12px;
  }
  .tui-image-editor-container .tui-image-editor-range-wrap {
    display: inline-block;
    margin-left: 4px;
  }
  .tui-image-editor-container .tui-image-editor-range-wrap.short .tui-image-editor-range {
    width: 100px;
  }
  .tui-image-editor-container .color-picker-control .tui-image-editor-range {
    margin-left: 10px;
    width: 108px;
  }
  .tui-image-editor-container .color-picker-control .tui-image-editor-virtual-range-pointer {
    background-color: #333;
  }
  .tui-image-editor-container .color-picker-control .tui-image-editor-virtual-range-bar {
    background-color: #ccc;
  }
  .tui-image-editor-container .color-picker-control .tui-image-editor-virtual-range-subbar {
    background-color: #606060;
  }
  .tui-image-editor-container .tui-image-editor-range-wrap.tui-image-editor-newline.short {
    margin-left: 19px;
    margin-top: -2px;
  }
  .tui-image-editor-container .tui-image-editor-range-wrap.tui-image-editor-newline.short label {
    color: #8e8e8e;
    font-weight: 400;
  }
  .tui-image-editor-container .tui-image-editor-range-wrap label {
    color: #fff;
    font-size: 11px;
    margin-right: 7px;
    vertical-align: baseline;
  }
  .tui-image-editor-container .tui-image-editor-range-value {
    background-color: #1c1c1c;
    border: 1px solid #d5d5d5;
    border-radius: 2px;
    box-shadow: none;
    color: #fff;
    cursor: default;
    font-weight: lighter;
    height: 24px;
    margin-left: 4px;
    margin-top: 15px;
    outline: none;
    text-align: center;
    vertical-align: baseline;
    width: 40px;
  }
  .tui-image-editor-container .tui-image-editor-controls {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-icpartition {
    background-color: #444;
    display: inline-block;
    height: 24px;
    width: 1px;
  }
  .tui-image-editor-container.left .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:before {
    border-bottom: 7px solid transparent;
    border-right: 7px solid #2f2f2f;
    border-top: 7px solid transparent;
    left: 28px;
    top: 11px;
  }
  .tui-image-editor-container.left .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:after {
    left: 42px;
    top: 7px;
    white-space: nowrap;
  }
  .tui-image-editor-container.left .tui-image-editor-submenu {
    height: 100%;
    left: 0;
    width: 248px;
  }
  .tui-image-editor-container.left .tui-image-editor-main-container {
    height: 100%;
    left: 64px;
    width: calc(100% - 64px);
  }
  .tui-image-editor-container.left .tui-image-editor-controls {
    display: table;
    height: 100%;
    width: 64px;
  }
  .tui-image-editor-container.left .tui-image-editor-menu,
  .tui-image-editor-container.right .tui-image-editor-menu {
    white-space: inherit;
  }
  .tui-image-editor-container.left .tui-image-editor-submenu,
  .tui-image-editor-container.right .tui-image-editor-submenu {
    white-space: normal;
  }
  .tui-image-editor-container.left .tui-image-editor-submenu > div,
  .tui-image-editor-container.right .tui-image-editor-submenu > div {
    vertical-align: middle;
  }
  .tui-image-editor-container.left .tui-image-editor-controls li,
  .tui-image-editor-container.right .tui-image-editor-controls li {
    display: inline-block;
    margin: 4px auto;
  }
  .tui-image-editor-container.left .tui-image-editor-icpartition,
  .tui-image-editor-container.right .tui-image-editor-icpartition {
    height: 1px;
    position: relative;
    top: -7px;
    width: 24px;
  }
  .tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-partition,
  .tui-image-editor-container.right .tui-image-editor-submenu .tui-image-editor-partition {
    display: block;
    margin: auto;
    width: 75%;
  }
  .tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-partition > div,
  .tui-image-editor-container.right .tui-image-editor-submenu .tui-image-editor-partition > div {
    border-bottom: 1px solid #3c3c3c;
    border-left: 0;
    height: 10px;
    margin: 0;
    width: 100%;
  }
  .tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-align,
  .tui-image-editor-container.right .tui-image-editor-submenu .tui-image-editor-submenu-align {
    margin-right: 0;
  }
  .tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li,
  .tui-image-editor-container.right .tui-image-editor-submenu .tui-image-editor-submenu-item li {
    margin-top: 15px;
  }
  .tui-image-editor-container.left
    .tui-image-editor-submenu
    .tui-image-editor-submenu-item
    .tui-colorpicker-clearfix
    li,
  .tui-image-editor-container.right
    .tui-image-editor-submenu
    .tui-image-editor-submenu-item
    .tui-colorpicker-clearfix
    li {
    margin-top: 0;
  }
  .tui-image-editor-container.left .tui-image-editor-checkbox-wrap.fixed-width,
  .tui-image-editor-container.right .tui-image-editor-checkbox-wrap.fixed-width {
    white-space: normal;
    width: 182px;
  }
  .tui-image-editor-container.left .tui-image-editor-range-wrap.tui-image-editor-newline label.range,
  .tui-image-editor-container.right .tui-image-editor-range-wrap.tui-image-editor-newline label.range {
    display: block;
    margin: auto;
    text-align: left;
    width: 75%;
  }
  .tui-image-editor-container.left .tui-image-editor-range,
  .tui-image-editor-container.right .tui-image-editor-range {
    width: 136px;
  }
  .tui-image-editor-container.right .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:before {
    border-bottom: 7px solid transparent;
    border-left: 7px solid #2f2f2f;
    border-top: 7px solid transparent;
    left: -3px;
    top: 11px;
  }
  .tui-image-editor-container.right .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:after {
    left: unset;
    right: 43px;
    top: 7px;
    white-space: nowrap;
  }
  .tui-image-editor-container.right .tui-image-editor-submenu {
    height: 100%;
    right: 0;
    width: 248px;
  }
  .tui-image-editor-container.right .tui-image-editor-main-container {
    height: 100%;
    right: 64px;
    width: calc(100% - 64px);
  }
  .tui-image-editor-container.right .tui-image-editor-controls {
    display: table;
    height: 100%;
    right: 0;
    width: 64px;
  }
  .tui-image-editor-container.bottom .tui-image-editor-submenu .tui-image-editor-partition.only-left-right,
  .tui-image-editor-container.top .tui-image-editor-submenu .tui-image-editor-partition.only-left-right {
    display: none;
  }
  .tui-image-editor-container.bottom .tui-image-editor-submenu > div {
    padding-bottom: 24px;
  }
  .tui-image-editor-container.top .color-picker-control .triangle {
    border-bottom: 8px solid #fff;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 0;
    top: -8px;
  }
  .tui-image-editor-container.top .tui-image-editor-size-wrap {
    height: 100%;
  }
  .tui-image-editor-container.top .tui-image-editor-main-container {
    bottom: 0;
  }
  .tui-image-editor-container.top .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:before {
    border-bottom: 7px solid #2f2f2f;
    border-top: 0;
    left: 13px;
    top: 33px;
  }
  .tui-image-editor-container.top .tui-image-editor-menu > .tui-image-editor-item[tooltip-content]:after {
    top: 38px;
  }
  .tui-image-editor-container.top .tui-image-editor-submenu {
    bottom: auto;
    top: 0;
  }
  .tui-image-editor-container.top .tui-image-editor-submenu > div {
    padding-top: 24px;
    vertical-align: top;
  }
  .tui-image-editor-container.top .tui-image-editor-controls-buttons,
  .tui-image-editor-container.top .tui-image-editor-controls-logo {
    display: table-cell;
  }
  .tui-image-editor-container.top .tui-image-editor-main {
    height: calc(100% - 64px);
    top: 64px;
  }
  .tui-image-editor-container.top .tui-image-editor-controls {
    bottom: inherit;
    top: 0;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.top {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.top .tie-panel-history {
    top: 45px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.top .opened .tie-panel-history:before {
    border-bottom: 8px solid #fff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    left: 90px;
    top: -8px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.top > .tui-image-editor-item[tooltip-content]:before {
    border: 7px solid transparent;
    border-bottom: 7px solid #2f2f2f;
    border-top: none;
    left: 13px;
    top: 35px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.top > .tui-image-editor-item[tooltip-content]:after {
    left: -4px;
    top: 41px;
    white-space: nowrap;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.top > .tui-image-editor-item[tooltip-content].opened:after,
  .tui-image-editor-container .tui-image-editor-help-menu.top > .tui-image-editor-item[tooltip-content].opened:before {
    content: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.bottom {
    bottom: 8px;
    height: 40px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    width: 506px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.bottom .tie-panel-history {
    bottom: 45px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.bottom .opened .tie-panel-history:before {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
    bottom: -8px;
    left: 90px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.bottom > .tui-image-editor-item[tooltip-content]:before {
    border: 7px solid transparent;
    border-bottom: none;
    border-top-color: #2f2f2f;
    bottom: 36px;
    left: 13px;
    top: auto;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.bottom > .tui-image-editor-item[tooltip-content]:after {
    bottom: 41px;
    left: -4px;
    top: auto;
    white-space: nowrap;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.bottom > .tui-image-editor-item[tooltip-content].opened:after,
  .tui-image-editor-container
    .tui-image-editor-help-menu.bottom
    > .tui-image-editor-item[tooltip-content].opened:before {
    content: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.left {
    height: 506px;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    white-space: inherit;
    width: 40px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.left .tie-panel-history {
    left: 140px;
    top: -4px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.left .opened .tie-panel-history:before {
    border-bottom: 8px solid transparent;
    border-right: 8px solid #fff;
    border-top: 8px solid transparent;
    left: -8px;
    top: 14px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.left .tui-image-editor-item {
    margin: 4px auto;
    padding: 6px 8px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.left > .tui-image-editor-item[tooltip-content]:before {
    border: 7px solid transparent;
    border-left: none;
    border-right-color: #2f2f2f;
    left: 27px;
    top: 11px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.left > .tui-image-editor-item[tooltip-content]:after {
    left: 40px;
    top: 7px;
    white-space: nowrap;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.left > .tui-image-editor-item[tooltip-content].opened:after,
  .tui-image-editor-container .tui-image-editor-help-menu.left > .tui-image-editor-item[tooltip-content].opened:before {
    content: none;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.right {
    height: 506px;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    white-space: inherit;
    width: 40px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.right .tie-panel-history {
    right: -30px;
    top: -4px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.right .opened .tie-panel-history:before {
    border-bottom: 8px solid transparent;
    border-left: 8px solid #fff;
    border-top: 8px solid transparent;
    right: -8px;
    top: 14px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.right .tui-image-editor-item {
    margin: 4px auto;
    padding: 6px 8px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.right > .tui-image-editor-item[tooltip-content]:before {
    border: 7px solid transparent;
    border-left: 7px solid #2f2f2f;
    border-right: none;
    left: -6px;
    top: 11px;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.right > .tui-image-editor-item[tooltip-content]:after {
    left: auto;
    right: 39px;
    top: 7px;
    white-space: nowrap;
  }
  .tui-image-editor-container .tui-image-editor-help-menu.right > .tui-image-editor-item[tooltip-content].opened:after,
  .tui-image-editor-container
    .tui-image-editor-help-menu.right
    > .tui-image-editor-item[tooltip-content].opened:before {
    content: none;
  }
  .tui-image-editor-container .tie-icon-add-button .tui-image-editor-button {
    min-width: 42px;
  }
  .tui-image-editor-container .svg_ic-helpmenu,
  .tui-image-editor-container .svg_ic-menu {
    height: 24px;
    width: 24px;
  }
  .tui-image-editor-container .svg_ic-submenu {
    height: 32px;
    width: 32px;
  }
  .tui-image-editor-container .svg_img-bi {
    height: 26px;
    width: 257px;
  }
  .tui-image-editor-container .tui-image-editor-controls svg > use,
  .tui-image-editor-container .tui-image-editor-help-menu svg > use {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-controls .enabled svg:hover > use.hover,
  .tui-image-editor-container .tui-image-editor-controls .normal svg:hover > use.hover,
  .tui-image-editor-container .tui-image-editor-help-menu .enabled svg:hover > use.hover,
  .tui-image-editor-container .tui-image-editor-help-menu .normal svg:hover > use.hover {
    display: block;
  }
  .tui-image-editor-container .tui-image-editor-controls .active svg:hover > use.hover,
  .tui-image-editor-container .tui-image-editor-help-menu .active svg:hover > use.hover {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-controls .active svg > use.active,
  .tui-image-editor-container .tui-image-editor-controls .enabled svg > use.enabled,
  .tui-image-editor-container .tui-image-editor-controls .on svg > use.hover,
  .tui-image-editor-container .tui-image-editor-controls .opened svg > use.hover,
  .tui-image-editor-container .tui-image-editor-controls svg > use.normal,
  .tui-image-editor-container .tui-image-editor-help-menu .active svg > use.active,
  .tui-image-editor-container .tui-image-editor-help-menu .enabled svg > use.enabled,
  .tui-image-editor-container .tui-image-editor-help-menu .on svg > use.hover,
  .tui-image-editor-container .tui-image-editor-help-menu .opened svg > use.hover,
  .tui-image-editor-container .tui-image-editor-help-menu svg > use.normal {
    display: block;
  }
  .tui-image-editor-container .tui-image-editor-controls .active svg > use.normal,
  .tui-image-editor-container .tui-image-editor-controls .enabled svg > use.normal,
  .tui-image-editor-container .tui-image-editor-help-menu .active svg > use.normal,
  .tui-image-editor-container .tui-image-editor-help-menu .enabled svg > use.normal {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-controls .help.enabled svg > use.normal,
  .tui-image-editor-container .tui-image-editor-controls .help svg > use.disabled,
  .tui-image-editor-container .tui-image-editor-help-menu .help.enabled svg > use.normal,
  .tui-image-editor-container .tui-image-editor-help-menu .help svg > use.disabled {
    display: block;
  }
  .tui-image-editor-container .tui-image-editor-controls .help.enabled svg > use.disabled,
  .tui-image-editor-container .tui-image-editor-help-menu .help.enabled svg > use.disabled {
    display: none;
  }
  .tui-image-editor-container .tui-image-editor-controls:hover {
    z-index: 3;
  }
  .tui-image-editor-container div.tui-colorpicker-clearfix {
    background-color: #f5f5f5;
    border: 1px solid #d5d5d5;
    border-radius: 2px;
    height: 28px;
    margin-top: 6px;
    padding: 4px 7px;
    width: 159px;
  }
  .tui-image-editor-container .tui-colorpicker-palette-hex {
    background-color: #f5f5f5;
    border: 0;
    font-size: 11px;
    margin-top: 2px;
    width: 114px;
  }
  .tui-image-editor-container .tui-colorpicker-palette-hex[value=''] + .tui-colorpicker-palette-preview,
  .tui-image-editor-container .tui-colorpicker-palette-hex[value='#ffffff'] + .tui-colorpicker-palette-preview {
    border: 1px solid #ccc;
  }
  .tui-image-editor-container .tui-colorpicker-palette-hex[value=''] + .tui-colorpicker-palette-preview {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAdBJREFUWAnFl0FuwjAQRZ0ukiugHqFSOQNdseuKW3ALzkA4BateICvUGyCxrtRFd4WuunH/TzykaYJrnLEYaTJJsP2+x8GZZCbQrLU5mj7Bn+EP8HvnCObd+R7xBV5lWfaNON4AnsA38E94qLEt+0yiFaBzAV/Bv+Cxxr4co7hKCDpw1q9wLeNYYdlAwyn8TYt8Hme3+8D5ozcTaMCZ68PXa2tnM2sbEcOZAJhrrpl2DAcTOGNjZPSfCdzkw6JrfbiMv+osBe4y9WOedhm4jZfhbENWuxS44H9Wz/xw4WzqLOAqh1+zycgAwzEMzr5k5gaHOa9ULBwuuDkFlHI1Kl4PJ66kgIpnoywOTmRFAYcbwYk9UMApWkD8zAV5ihcwHk4Rx7gl0IFTQL0EFc+CTQ9OZHWH3YhlVJiVpTHbrTGLhTHLZVgff6s9lyBsI9KduSS83oj+34rTwJutmBmCnMsvozRwZqB5GTkBw6/jdPDu69iJ6BYk6eCcfbcgcQIK/MByaaiMqm8rHcjol2TnpWDhyAKSGdA3FrxtJUToX0ODqatetfGE+8tyEUOV8GY5dGRwLP/MBS4RHQr4bT7NRAQjlcOTfZxmv2G+c4hI8nn+Ax5PG/zhI393AAAAAElFTkSuQmCC);
    background-size: cover;
  }
  .tui-image-editor-container .tui-colorpicker-palette-preview {
    border: 0;
    border-radius: 100%;
    float: left;
    height: 17px;
    width: 17px;
  }
  .tui-image-editor-container .color-picker-control {
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 3px 22px 6px rgba(0, 0, 0, 0.15);
    display: none;
    padding: 16px;
    position: absolute;
    width: 192px;
    z-index: 99;
  }
  .tui-image-editor-container .color-picker-control .tui-colorpicker-palette-toggle-slider {
    display: none;
  }
  .tui-image-editor-container .color-picker-control .tui-colorpicker-palette-button {
    background-size: cover;
    border: 0;
    border-radius: 100%;
    font-size: 1px;
    margin: 2px;
  }
  .tui-image-editor-container .color-picker-control .tui-colorpicker-palette-button[title=''],
  .tui-image-editor-container .color-picker-control .tui-colorpicker-palette-button[title='#ffffff'] {
    border: 1px solid #ccc;
  }
  .tui-image-editor-container .color-picker-control .triangle {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 8px solid #fff;
    bottom: -8px;
    height: 0;
    left: 84px;
    position: absolute;
    width: 0;
  }
  .tui-image-editor-container .color-picker-control .tui-colorpicker-container,
  .tui-image-editor-container .color-picker-control .tui-colorpicker-palette-container,
  .tui-image-editor-container .color-picker-control .tui-colorpicker-palette-container ul {
    height: auto;
    width: 100%;
  }
  .tui-image-editor-container .filter-color-item .color-picker-control label {
    font-color: #333;
    font-weight: 400;
    margin-right: 7pxleft;
  }
  .tui-image-editor-container .filter-color-item .tui-image-editor-checkbox {
    margin-top: 0;
  }
  .tui-image-editor-container .filter-color-item .tui-image-editor-checkbox > label:before,
  .tui-image-editor-container .filter-color-item .tui-image-editor-checkbox input + label:before {
    left: -16px;
  }
  .tui-image-editor-container .color-picker {
    height: auto;
    width: 100%;
  }
  .tui-image-editor-container .color-picker-value {
    border: 0;
    border-radius: 100%;
    height: 32px;
    margin: auto auto 1px;
    width: 32px;
  }
  .tui-image-editor-container .color-picker-value.transparent {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAdBJREFUWAnFl0FuwjAQRZ0ukiugHqFSOQNdseuKW3ALzkA4BateICvUGyCxrtRFd4WuunH/TzykaYJrnLEYaTJJsP2+x8GZZCbQrLU5mj7Bn+EP8HvnCObd+R7xBV5lWfaNON4AnsA38E94qLEt+0yiFaBzAV/Bv+Cxxr4co7hKCDpw1q9wLeNYYdlAwyn8TYt8Hme3+8D5ozcTaMCZ68PXa2tnM2sbEcOZAJhrrpl2DAcTOGNjZPSfCdzkw6JrfbiMv+osBe4y9WOedhm4jZfhbENWuxS44H9Wz/xw4WzqLOAqh1+zycgAwzEMzr5k5gaHOa9ULBwuuDkFlHI1Kl4PJ66kgIpnoywOTmRFAYcbwYk9UMApWkD8zAV5ihcwHk4Rx7gl0IFTQL0EFc+CTQ9OZHWH3YhlVJiVpTHbrTGLhTHLZVgff6s9lyBsI9KduSS83oj+34rTwJutmBmCnMsvozRwZqB5GTkBw6/jdPDu69iJ6BYk6eCcfbcgcQIK/MByaaiMqm8rHcjol2TnpWDhyAKSGdA3FrxtJUToX0ODqatetfGE+8tyEUOV8GY5dGRwLP/MBS4RHQr4bT7NRAQjlcOTfZxmv2G+c4hI8nn+Ax5PG/zhI393AAAAAElFTkSuQmCC);
    background-size: cover;
    border: 1px solid #cbcbcb;
  }
  .tui-image-editor-container .color-picker-value + label {
    color: #fff;
  }
  .tui-image-editor-container .tui-image-editor-submenu svg > use {
    display: none;
  }
  .tie-icon-add-button.icon-arrow-2 .tui-image-editor-button[data-icontype='icon-arrow-2'] svg > use.active,
  .tie-icon-add-button.icon-arrow-3 .tui-image-editor-button[data-icontype='icon-arrow-3'] svg > use.active,
  .tie-icon-add-button.icon-arrow .tui-image-editor-button[data-icontype='icon-arrow'] svg > use.active,
  .tie-icon-add-button.icon-bubble .tui-image-editor-button[data-icontype='icon-bubble'] svg > use.active,
  .tie-icon-add-button.icon-heart .tui-image-editor-button[data-icontype='icon-heart'] svg > use.active,
  .tie-icon-add-button.icon-location .tui-image-editor-button[data-icontype='icon-location'] svg > use.active,
  .tie-icon-add-button.icon-polygon .tui-image-editor-button[data-icontype='icon-polygon'] svg > use.active,
  .tie-icon-add-button.icon-star-2 .tui-image-editor-button[data-icontype='icon-star-2'] svg > use.active,
  .tie-icon-add-button.icon-star .tui-image-editor-button[data-icontype='icon-star'] svg > use.active,
  .tui-image-editor-container .tui-image-editor-submenu svg > use.normal {
    display: block;
  }
  .tie-draw-line-select-button.free .tui-image-editor-button.free svg > use.normal,
  .tie-draw-line-select-button.line .tui-image-editor-button.line svg > use.normal {
    display: none;
  }
  .tie-draw-line-select-button.free .tui-image-editor-button.free svg > use.active,
  .tie-draw-line-select-button.line .tui-image-editor-button.line svg > use.active {
    display: block;
  }
  .tie-flip-button.flipX .tui-image-editor-button.flipX svg > use.normal,
  .tie-flip-button.flipY .tui-image-editor-button.flipY svg > use.normal,
  .tie-flip-button.resetFlip .tui-image-editor-button.resetFlip svg > use.normal {
    display: none;
  }
  .tie-flip-button.flipX .tui-image-editor-button.flipX svg > use.active,
  .tie-flip-button.flipY .tui-image-editor-button.flipY svg > use.active,
  .tie-flip-button.resetFlip .tui-image-editor-button.resetFlip svg > use.active {
    display: block;
  }
  .tie-mask-apply.apply.active .tui-image-editor-button.apply label {
    color: #fff;
  }
  .tie-mask-apply.apply.active .tui-image-editor-button.apply svg > use.active {
    display: block;
  }
  .tie-crop-button .tui-image-editor-button.apply,
  .tie-crop-preset-button .tui-image-editor-button.apply {
    margin-right: 24px;
  }
  .tie-crop-button .tui-image-editor-button.apply.active svg > use.active,
  .tie-crop-button .tui-image-editor-button.preset.active svg > use.active,
  .tie-crop-preset-button .tui-image-editor-button.apply.active svg > use.active,
  .tie-crop-preset-button .tui-image-editor-button.preset.active svg > use.active {
    display: block;
  }
  .tie-resize-button .tui-image-editor-button.apply,
  .tie-resize-preset-button .tui-image-editor-button.apply {
    margin-right: 24px;
  }
  .tie-resize-button .tui-image-editor-button.apply.active svg > use.active,
  .tie-resize-button .tui-image-editor-button.preset.active svg > use.active,
  .tie-resize-preset-button .tui-image-editor-button.apply.active svg > use.active,
  .tie-resize-preset-button .tui-image-editor-button.preset.active svg > use.active {
    display: block;
  }
  .tie-shape-button.circle .tui-image-editor-button.circle svg > use.normal,
  .tie-shape-button.rect .tui-image-editor-button.rect svg > use.normal,
  .tie-shape-button.triangle .tui-image-editor-button.triangle svg > use.normal {
    display: none;
  }
  .tie-shape-button.circle .tui-image-editor-button.circle svg > use.active,
  .tie-shape-button.rect .tui-image-editor-button.rect svg > use.active,
  .tie-shape-button.triangle .tui-image-editor-button.triangle svg > use.active,
  .tie-text-align-button.tie-text-align-center .tui-image-editor-button.center svg > use.active,
  .tie-text-align-button.tie-text-align-left .tui-image-editor-button.left svg > use.active,
  .tie-text-align-button.tie-text-align-right .tui-image-editor-button.right svg > use.active,
  .tie-text-effect-button .tui-image-editor-button.active svg > use.active {
    display: block;
  }
  .tie-icon-image-file,
  .tie-mask-image-file {
    border: 1px solid green;
    cursor: inherit;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .tie-zoom-button.flipX .tui-image-editor-button.flipX svg > use.normal,
  .tie-zoom-button.flipY .tui-image-editor-button.flipY svg > use.normal,
  .tie-zoom-button.resetFlip .tui-image-editor-button.resetFlip svg > use.normal {
    display: none;
  }
  .tie-zoom-button.flipX .tui-image-editor-button.flipX svg > use.active,
  .tie-zoom-button.flipY .tui-image-editor-button.flipY svg > use.active,
  .tie-zoom-button.resetFlip .tui-image-editor-button.resetFlip svg > use.active {
    display: block;
  }
  .tui-image-editor-container.top.tui-image-editor-top-optimization .tui-image-editor-controls ul {
    text-align: right;
  }
  .tui-image-editor-container.top.tui-image-editor-top-optimization .tui-image-editor-controls-logo {
    display: none;
  }
`;
